import { SearchService } from "../../Logic/Search/SearchService";
import {
  SEARCH_SET_INDEX,
  SEARCH_SET_QUERY,
  SEARCH_LOAD_FAILURE,
} from "./SearchActionTypes";
import type { ISearchGrouped } from "@model/Search.model";

export const searchSetQuery = (q: string) => ({
  type: SEARCH_SET_QUERY,
  payload: q,
});
export const searchSetIndex = (payload: ISearchGrouped) => ({
  type: SEARCH_SET_INDEX,
  payload,
});
export const searchLoadFailure = (message: string) => ({
  type: SEARCH_LOAD_FAILURE,
  payload: message,
});

const EMPTY: ISearchGrouped = { categories: [], products: [], services: [] };

export const loadSearchIndex = () => async (dispatch: any) => {
  const searchService = new SearchService();

  try {
    const data =
      (await searchService.handleSearch({
        q: "",
        setApiError: (err) =>
          dispatch(searchLoadFailure(err ?? "Couldn’t fetch search data.")),
        setLoading: () => {},
      })) ?? EMPTY;

    dispatch(searchSetIndex(data));
  } catch (e) {
    const msg = (e as Error)?.message || "Couldn’t fetch search data.";
    dispatch(searchSetIndex(EMPTY));
    dispatch(searchLoadFailure(msg));
  }
};
